/* Blanks Broker — PDP enhancements.
 * Two pieces of microcopy that react to qty/variant changes:
 *   1. "X cartons" hint next to the qty input (qty / carton_qty)
 *   2. Dynamic add-to-cart button label: "Add 50 to cart · $280.00"
 */
(function () {
  'use strict';

  function moneyFormat(amountCents) {
    if (window.Shopify && window.Shopify.formatMoney && window.Shopify.money_format) {
      try { return window.Shopify.formatMoney(amountCents, window.Shopify.money_format); } catch (e) { /* fall through */ }
    }
    return '$' + (amountCents / 100).toFixed(2);
  }

  // Parse a money string like "$8.40" or "Rs. 1,250.00" into integer cents.
  function parseMoneyToCents(text) {
    if (!text) return null;
    var cleaned = String(text).replace(/[^\d.,-]/g, '');
    // Reduce to first two decimal segments.
    var match = cleaned.match(/-?[\d,]+(?:\.\d+)?/);
    if (!match) return null;
    var num = parseFloat(match[0].replace(/,/g, ''));
    if (isNaN(num)) return null;
    return Math.round(num * 100);
  }

  function readUnitPriceCents(productInfo) {
    // Prefer the active "last" price (sale or regular), fall back to regular.
    var sel = '.price-item.price-item--last, .price-item.price-item--regular';
    var els = productInfo.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) {
      var visible = els[i].offsetParent !== null || els[i].textContent.trim().length > 0;
      if (visible) {
        var cents = parseMoneyToCents(els[i].textContent);
        if (cents != null) return cents;
      }
    }
    return null;
  }

  function pluralize(n, one, many) { return n === 1 ? one : many; }

  function init(productInfo) {
    var cartonQty = parseInt(productInfo.getAttribute('data-bb-carton-qty'), 10);
    var qtyInput = productInfo.querySelector('input[name="quantity"], input.quantity__input');
    var form = productInfo.querySelector('form[action*="/cart/add"], product-form form');
    if (!qtyInput || !form) return;

    var addBtn = form.querySelector('button[name="add"]');
    var addBtnSpan = addBtn ? addBtn.querySelector('span:not(.loading-overlay__spinner):not(.visually-hidden)') : null;
    var originalAddText = addBtnSpan ? addBtnSpan.textContent.trim() : null;

    var cartonHint = productInfo.querySelector('[data-bb-carton-microcopy]');

    function update() {
      var qty = parseInt(qtyInput.value, 10);
      if (isNaN(qty) || qty < 1) qty = 1;

      // (1) Carton-count microcopy — disabled (not selling by the carton right now).
      //     Force-hide regardless of carton_qty metafield so seeded products don't surface stale copy.
      if (cartonHint) cartonHint.hidden = true;

      // (2) Dynamic add-to-cart label — only when the button is enabled.
      if (addBtnSpan && originalAddText && !addBtn.disabled) {
        var unitCents = readUnitPriceCents(productInfo);
        if (unitCents != null) {
          var totalCents = unitCents * qty;
          addBtnSpan.textContent = 'Add ' + qty + ' to cart · ' + moneyFormat(totalCents);
        } else {
          addBtnSpan.textContent = originalAddText;
        }
      } else if (addBtnSpan) {
        // Disabled state — let Dawn's "Sold out" / "Unavailable" stand.
      }
    }

    qtyInput.addEventListener('input', update);
    qtyInput.addEventListener('change', update);

    if (window.PUB_SUB_EVENTS && window.subscribe) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function () {
        // Wait a tick for Dawn to swap the price DOM, then recompute.
        setTimeout(update, 50);
      });
    }

    update();
  }

  function bootstrap() {
    var nodes = document.querySelectorAll('product-info[data-bb-carton-qty]');
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  // Re-init if a product-info is re-rendered (theme editor or quick-view).
  document.addEventListener('shopify:section:load', bootstrap);
})();
